import { useTranslation } from 'react-i18next'

/**
 * Safe translator: never returns the raw i18n key to the UI.
 * If a translation is missing, returns a supplied defaultValue (or empty string).
 *
 * This prevents "key echo" where users see technical keys like "connect.modal.title"
 * instead of actual translated text.
 */
export function useSafeT() {
  const { t } = useTranslation()

  return (
    key: string,
    options?: Record<string, unknown> & { defaultValue?: string },
  ) => {
    const translated = t(key, options)

    // Check if the translation looks like a raw key (contains dots and matches the input)
    const looksLikeKey =
      typeof translated === 'string' && translated === key && key.includes('.')

    if (looksLikeKey) {
      // Log missing key for monitoring
      console.warn(`Missing translation key: "${key}"`)
      return options?.defaultValue ?? ''
    }

    return translated
  }
}

export default useSafeT
